
<template>
  <div class="mt-4">
    <header @click="expanded = !expanded" class="flex header">
      <font-awesome-icon
        v-if="pupils.length > 0"
        :icon="expanded ? 'chevron-down' : 'chevron-right'"
        class="mr-2"
      />
      {{name}}
    </header>
    <section class="searchTable" v-if="expanded == true">
      <table>
        <tr v-for="pupil in pupils" :key="pupil.id" @click.prevent="openGraph(pupil.name)">
          <td class="tableCell" style="width: 100%">
            <a href="" target="_blank" style="color: white; text-decoration:none" @click.prevent="openGraph(pupil.name)">{{ pupil.name }}</a>
          </td>
          <td class="tableCell">
            <font-awesome-icon
              :icon="['fas', 'folder-open']"
              class="mr-2"
              @click="openGraph(pupil.name)"
            />
          </td>
        </tr>
      </table>
    </section>
  </div>
</template>

<script>
import { fetchClass, fetchPupilsOfClass } from "../firebase/firebase";

export default {
  name: "class",
  props: {
    schoolid: {
      type: String,
      required: true
    },
    classid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      unsubscribe: null,
      name: "",
      pupils: [],
      expanded: true
    };
  },
  methods: {
    openGraph: function(name) {
      if (name === "Tobias Lindener") {
        this.$store.commit("global/setSelectedGraph", 2);
      }else if (name === "Thomas Reinecke") {
        this.$store.commit("global/setSelectedGraph", 3);
      }else{
        this.$store.commit("global/setSelectedGraph", 1);  
      }
    }
  },
  async created() {
    this.unsubscribe = fetchClass(this.schoolid, this.classid).onSnapshot(
      onSnapshot => {
        const $data = onSnapshot.data();
        this.name = $data.name;
      }
    );
    this.pupils = await fetchPupilsOfClass(this.schoolid, this.classid);
  },
  destroyed() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
}
.header {
  font-size: 24px;
  margin-bottom: 4px;
}
.header:hover {
  cursor: pointer;
}
.mr-2 {
  margin-right: 4px;
}
.mt-4 {
  margin-top: 16px;
}
.ml-4 {
  margin-left: 16px;
}
.mv-2 {
  margin-top: 4px;
  margin-bottom: 4px;
}
.pupil:hover {
  cursor: pointer;
}
</style>